<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="900" scrollable>
			<v-card>
				<v-card-title class="headline">
					<span>Detail Pemesanan</span>
					<span class="pl-2 font-weight-bold">{{ detailPO.po_code }}</span>
				</v-card-title>
				<v-card-text class="black--text">
					<v-row class="mb-3">
						<v-col cols="6" md="6">
							<div class="text-subtitle-1 font-weight-bold">Detail Supplier</div>
							<div class="pt-1">{{detailPO.supplier_name}}</div>
							<div class="pt-1">{{detailPO.supplier_email}}</div>
							<div class="pt-1">{{detailPO.supplier_mobilephone}}</div>
							<div class="pt-1">{{addressText(detailPO)}}</div>
						</v-col>
						<v-col cols="6" md="6">
							<div class="text-subtitle-1 font-weight-bold">Status Pembayaran</div>
							<v-col cols="6" class="mt-1 pa-0">
								<div v-if="detailPO.po_payment_method == 'lunas'" class="primary rounded text-subtitle-1 text-uppercase white--text text-center text-uppercase font-weight-bold pa-2 d-flex justify-center">
									<span color="white"><v-icon color="white">mdi-check-circle</v-icon></span>
									<div class="pl-3">{{ detailPO.po_payment_method }}</div>
								</div>
								<div v-else class="orange rounded text-subtitle-1 text-uppercase white--text text-center text-uppercase font-weight-bold pa-2 d-flex justify-center">
									<span><v-img width="15" class="mt-1" src="/assets/icon/tempo-icon.png"></v-img></span>
									<span class="pl-3">{{detailPO.po_payment_method}}</span>
								</div>
							</v-col>
							<div class="text-subtitle-1 mt-3 font-weight-bold">Catatan</div>
							<v-col cols="12" class="pa-0">
								<div class="pt-1">{{detailPO.po_note ? detailPO.po_note : '-'}}</div>
							</v-col>
						</v-col>
					</v-row>
					<v-list color="deep-purple lighten-5" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">detail produk</div>
						</v-list-item>
					</v-list>
					<v-card class="mb-5 elevation-0">
						<v-data-table :headers="headers" :items="detailPO.po_detail" hide-default-footer>
							<template v-slot:item.po_detail_quantity_requested="{ item }">
								<div>{{ item.po_detail_quantity_requested | toNumber }} {{ item.po_detail_product_unit }}</div>
							</template>
							<template v-slot:item.po_detail_quantity_approved="{ item }">
								<div>{{ item.po_detail_quantity_approved | toNumber }} {{ item.po_detail_product_unit }}</div>
							</template>
							<template v-slot:item.po_detail_quantity_delivered="{ item }">
								<div>{{ item.po_detail_quantity_delivered | toNumber }} {{ item.po_detail_product_unit }}</div>
							</template>
							<template v-slot:item.po_detail_quantity_transport="{ item }">
								<div>{{ item.po_detail_quantity_transport | toNumber }} {{ item.po_detail_product_unit }}</div>
							</template>
						</v-data-table>
					</v-card>
					<v-list color="deep-purple lighten-5" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">Jadwal Pengiriman</div>
						</v-list-item>
					</v-list>
					<div v-if="Object.values(poSchedules).length > 0">
						<v-card class="mb-5 elevation-0" outlined v-for="(a, index) in poSchedules" :key="index" >
							<v-card-title class="text-subtitle-1 font-weight-bold deep-purple lighten-5">
								<span class="grey--text text--darken-2">{{index | haritanggal}}</span>
							</v-card-title>
							<v-data-table :headers="scheduleHeaders" :items="a" hide-default-footer>
								<template v-slot:item.po_schedule_detail_quantity="{ item }">
									<div>{{ item.po_schedule_detail_quantity | toNumber }} {{ item.product_unit }}</div>
								</template>
							</v-data-table>
						</v-card>
					</div>
					<div v-else class="pb-5">
						<not-found></not-found>
					</div>
					<v-list color="deep-purple lighten-5" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">status pemesanan</div>
						</v-list-item>
					</v-list>
					<v-row class="mb-3" v-if="detailPO.po_status_closed_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailPO.po_status == 'closed' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'closed' | toStatusPOWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailPO.po_status_closed_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailPO.po_status_supp_processed_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailPO.po_status == 'supp_processed' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'supp_processed' | toStatusPOWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailPO.po_status_supp_processed_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailPO.po_status_supp_approved_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailPO.po_status == 'supp_approved' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'supp_approved' | toStatusPOWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailPO.po_status_supp_approved_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailPO.po_status_supp_rejected_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailPO.po_status == 'supp_rejected' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'supp_rejected' | toStatusPOWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailPO.po_status_supp_rejected_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailPO.po_status_wh_approved_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailPO.po_status == 'wh_approved' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'wh_approved' | toStatusPOWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailPO.po_status_wh_approved_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailPO.po_status_wh_rejected_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailPO.po_status == 'wh_rejected' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'wh_rejected' | toStatusPOWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailPO.po_status_wh_rejected_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailPO.po_status_created_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailPO.po_status == 'created' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'created' | toStatusPOWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{ detailPO.po_status_created_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>

				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideDialog">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			singleSelect: false,
			selected: [],
			headers: [
			{ text: 'Nama Produk', value: 'po_detail_product_name', sortable: false},
			{ text: 'Jumlah Pesanan', value: 'po_detail_quantity_requested', sortable: false, align: 'center' },
			{ text: 'Jumlah Approve', value: 'po_detail_quantity_approved', sortable: false, align: 'center' },
			{ text: 'Jumlah Diterima', value: 'po_detail_quantity_delivered', sortable: false, align: 'center' },
			{ text: 'Jumlah Dikirim', value: 'po_detail_quantity_transport', sortable: false, align: 'center' },
			],
			scheduleHeaders: [
			{ text: 'Nama Produk', value: 'product_name', sortable: false, width: '50%'},
			{ text: 'Kode Produk', value: 'product_code', sortable: false, width: '30%'},
			{ text: 'Jumlah', value: 'po_schedule_detail_quantity', sortable: false, align: 'center', width: '20%'},
			],
		}
	},
	computed:{
		...mapState('po', ['detailPO']),

		poSchedules() {
			let schedule = []
			if (this.detailPO.po_schedules) {
				schedule = this.detailPO.po_schedules.reduce((r, a) => {
					r[a.po_schedule_detail_date] = [...r[a.po_schedule_detail_date] || [], a];
					return r;
				}, {});
			}
			return schedule
		},
	},
	props: {
		dialog: Boolean
	},
	methods :{
		hideDialog(){
			this.$emit('hideDialog')
		},
		addressText(value) {
			var data = []
			if (value.supplier_address)
				data.push(value.supplier_address)
			if (value.supplier_subdistrict_name)
				data.push(value.supplier_subdistrict_name)
			if (value.supplier_city_name)
				data.push(value.supplier_city_name)
			if (value.supplier_province_name)
				data.push(value.supplier_province_name)
			return data.join(', ')
		}
	}
}
</script>